import { render, staticRenderFns } from "./HeaderSwiper.vue?vue&type=template&id=4aec3a56&scoped=true"
import script from "./HeaderSwiper.vue?vue&type=script&lang=js"
export * from "./HeaderSwiper.vue?vue&type=script&lang=js"
import style0 from "./HeaderSwiper.vue?vue&type=style&index=0&id=4aec3a56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aec3a56",
  null
  
)

export default component.exports